import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFast = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Promotion_Rocket",
	"data-name": "Promotion, Rocket",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11614",
			"data-name": "Path 11614",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11615",
			"data-name": "Path 11615",
			d: "M12.94,11.06,5.87,18.13",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11616",
			"data-name": "Path 11616",
			d: "M6.633,13,3.17,12.181a.5.5,0,0,1-.239-.84L5.685,8.587a1,1,0,0,1,.7-.293l3.105-.027",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11617",
			"data-name": "Path 11617",
			d: "M19.879,8.975l.808-3.888a1.5,1.5,0,0,0-1.774-1.774l-3.888.808A5.993,5.993,0,0,0,12,5.753L8.814,8.942a8.006,8.006,0,0,0-2.259,4.5l-.011.073a3.481,3.481,0,0,0,.982,2.961h0a3.476,3.476,0,0,0,2.961.981l.073-.011a8,8,0,0,0,4.5-2.259L18.247,12a5.993,5.993,0,0,0,1.632-3.021Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11618",
			"data-name": "Path 11618",
			d: "M13.4,4.714A22.415,22.415,0,0,1,19.286,10.6",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11619",
			"data-name": "Path 11619",
			d: "M11,17.367l.818,3.463a.5.5,0,0,0,.84.239l2.754-2.754a1,1,0,0,0,.293-.7l.027-3.1",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgFast;
